import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import entryActions from '../entry-actions';
import PointSystemModal from '../components/PointSystemModal';
import selectors from '../selectors';

const mapStateToProps = (state) => {
  const pointSystem = selectors.selectPointSystemForCurrentBoard(state);
  return {
    open: true,
    pointSystem,
    employeePlans: selectors.selectEmployeePlansForCurrentBoardPointSystem(state),
    dampingCoefficients: selectors.selectDampingCoefficientsForPointSystem(
      state,
      pointSystem?.id,
    ),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClose: entryActions.closeModal,
      onEmployeePlansFetch: entryActions.fetchEmployeePlansInCurrentBoard,
      onEmployeePlanCreate: entryActions.createEmployeePlanInCurrentBoard,
      onEmployeePlanUpdate: entryActions.updateEmployeePlan,
      onEmployeePlanDelete: entryActions.deleteEmployeePlan,
      onContentViewPlanGetOrCreate: entryActions.getOrCreateContentViewPlanInCurrentBoard,
      onContentViewPlanUpdate: entryActions.updateContentViewPlan,
      onContentCardDefaultsFetch: entryActions.fetchContentCardDefaultsInCurrentBoard,
      onContentCardDefaultCreate: entryActions.createContentCardDefaultInCurrentBoard,
      onContentCardDefaultUpdate: entryActions.updateContentCardDefault,
      onContentCardDefaultDelete: entryActions.deleteContentCardDefault,
      onDampingCoefficientsFetch: entryActions.fetchDampingCoefficientsInCurrentBoard,
      onDampingCoefficientCreate: entryActions.createDampingCoefficient,
      onDampingCoefficientUpdate: entryActions.updateDampingCoefficient,
      onDampingCoefficientDelete: entryActions.deleteDampingCoefficient,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PointSystemModal);
